import React, { useState, useEffect } from "react";
import { useParams, useHistory } from "react-router";
import { Link } from "react-router-dom";

import Api from "../Api/Api";
import { isAuthenticated, isLoggedIn } from "../Auth/isAuthenticated";

import { ToastContainer } from 'react-toastify';
import { toastSuccess, toastWarning } from "../utilis/toast"
import 'react-toastify/dist/ReactToastify.css';
import Slider from "react-slick";
import { FiShare2 } from "react-icons/fi";
import { Helmet } from "react-helmet-async";


import { windowScrollUp } from '../utilis/window'
import { API, username } from "../API";
import { crewSettingsVideos } from "../Config/Slider";
import axios from "axios";
import { isAutheticated } from "./auth/authhelper";
import NavBar from "./Navbar";

const MovieView = () => {
  const { token } = isAutheticated()
  // console.log(token)
  const history = useHistory();
  const [checkWatchlist, setCheckwatchlist] = useState(null)
  const [movie, setMovie] = useState(null);
  const [vediocategory, setvediocategory] = useState("");
  const [vediocategoryLogo, setvediocategoryLogo] = useState("");
  const [vediocategoryId, setvediocategoryId] = useState(null);

  const { slug } = useParams(); // Get the slug from URL

  // Extract the movie ID from the slug (the last part after '-')
  const videoid = slug?.split("-").pop();

  // const { videoid, username } = useParams();
  // const { video_Title, videoid } = useParams();
  useEffect(() => {
    const getData = async () => {
      const { data } = await Api.getMovieInfo(username, videoid);
      console.log('viewmovibbbbbbbbb', data);
      setMovie(data);
      setvediocategory(data?.category?.name)
      setvediocategoryId(data?.category?.name)
      setvediocategoryLogo(data?.category?.CategoryLogo?.url)
    };
    getData();
  }, [videoid]);

  useEffect(() => {
    const getData = async () => {
      const { video } = await Api.getWatchList();
      console.log(video);
      let check = false
      for (let i = 0; i < video?.length; i++) {
        if (video[i]._id === videoid) {
          check = true
          setCheckwatchlist(true)
          break;
        }
      }
      if (!check) {
        setCheckwatchlist(false)
      }
    };
    getData();
  }, [videoid]);
  const removeFromWatchlistHandler = async () => {
    windowScrollUp();
    try {
      await Api.RemoveFromWatchlist(videoid);
      setCheckwatchlist(false)
      toastSuccess(`Removed from WatchList`)
    } catch (e) {
      console.log(e);
    }
  }
  const [subscription, setSubscription] = useState(false)
  const [plan, setAllPlane] = useState({})


  //subscription check
  useEffect(() => {
    axios.get(`${API}/api/subscription/setting`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then(response => {
        const { data } = response?.data;
        setSubscription(data?.subscriptionRequired)
        setAllPlane(data?.plans)

        // Ensure the data contains the expected properties before setting state
        // if (data) {
        //   setLoginRequired(data.loginRequired || false);
        //   setPayRequired(data.payRequired || false);
        //   setSubscriptionRequired(data.subscriptionRequired || false);
        //   setPlans({
        //     monthly: data?.plans?.monthly || { enabled: false, value: "" },
        //     quarterly: data?.plans?.quarterly || { enabled: false, value: "" },
        //     halfYearly: data?.plans.halfYearly || { enabled: false, value: "" },
        //     yearly: data?.plans.yearly || { enabled: false, value: "" },
        //   });
        // }
      })
      .catch(err => {
        const errorMessage = err.response?.data?.error || err.message || 'An error occurred while fetching the subscription settings';
        alert(`Error fetching subscription settings: ${errorMessage}`);
        console.error("Error fetching subscription settings:", err);
      })

  }, [token]);
  //






  const addToWatchlistHandler = async () => {
    // if (isAuthenticated()) {
    windowScrollUp();
    try {

      const data = await axios.post(
        `${API}/api/watchlist/add_watchlist/${videoid}`, {}, {
        headers: {
          "Access-Control-Allow-Origin": "*",
          // Authorization: `Bearer ${localStorage.getItem("id_token")}`,
          Authorization: `Bearer ${token}`,
        }
      }
      );

      setCheckwatchlist(true)
      toastSuccess(`Added in WatchList`)
    } catch (e) {
      toastWarning(`All Ready in WatchList`);
    }
    // } else if (isLoggedIn()) history.push(`/${username}/details/payment`)
    // else history.push(`/${username}/login`)
  }
  // share movi btn

  // const handleShare = async () => {
  //   const shareData = {
  //     banner: movie.banner || movie?.thumbnail || "/default-banner.jpg", // Fallback for banner image
  //     title: movie?.title || "Check out this movie!", // Fallback for title
  //     text: `Watch ${movie?.title || "this amazing movie"} on our platform!`,
  //     url: `${window.location.origin}/view/${videoid || "default-video-id"}`, // Fallback for video ID
  //   };

  //   if (navigator.share) {
  //     try {
  //       await navigator.share(shareData);
  //       // toastSuccess("Movie link shared successfully!");
  //     } catch (err) {
  //       console.error("Error sharing the link:", err);
  //       toastWarning("Failed to share the link.");
  //     }
  //   } else {
  //     navigator.clipboard.writeText(shareData.url);
  //     // toastSuccess("Movie link copied to clipboard!");
  //   }
  // };


  const handleShare = async () => {
    const shareText = `🎬 ${movie?.title || "Check out this Video!"}\n\n📜 ${movie?.description || "Watch this amazing video now!"}\n\n🔗 Watch here: ${window.location.origin}/view/${slug}`;

    if (navigator.share) {
      try {
        await navigator.share({
          title: movie?.title || "Check out this video!",
          text: shareText,
          url: `${window.location.origin}/view/${slug}`,
        });
      } catch (err) {
        console.error("Error sharing the link:", err);
      }
    } else {
      // Fallback: Copy to clipboard
      navigator.clipboard.writeText(shareText);
      toastSuccess("video details copied! Paste it to share.");
    }
  };
  console.log(vediocategory)
  return (
    <>
      <Helmet>
        <title>
          {movie?.title
            ? `${movie.title} - OTT Channel | Watch Now`
            : "Explore Videos - OTT Channel"}
        </title>
        <meta
          name="description"
          content={`Discover ${movie?.title?.toLowerCase() || "amazing videos"} on our OTT channel. Watch exclusive movies, TV shows, and more.`}
        />
        <meta
          name="keywords"
          content={`${movie?.title || "Videos"}, OTT Channel, Streaming, Exclusive Movies, TV Shows`}
        />
      </Helmet>



      <NavBar categoryLogo={vediocategoryLogo} category={vediocategory} categoryId={vediocategoryId} />
      {(videoid === undefined || username === undefined) && (
        <h2 className="movie-name">NoT valid movie</h2>
      )}
      {movie && (
        <div className="px-3 px-md-5 px-lg-7">
          {/* Banner or Thumbnail */}
          <div
            style={{
              position: "relative",
              height: "90vh",
              overflow: "hidden",
            }}
          >
            {/* Movie Banner Image */}
            <img
              src={movie.banner ? movie.banner : movie.thumbnail}
              alt={movie.Plot || "Movie Banner"}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />

            {/* Play or Pay Button */}
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Link
                to={() => {
                  if (!subscription) {

                    const category = encodeURIComponent(vediocategory || "default-category");

                    const videoUrl = encodeURIComponent(movie?.video || "https://default-video-url.com");



                    return `/${category}/${slug}/play?v=${videoUrl}`;

                  } else if (subscription) {
                    return `/${username}/details/payment`;
                  } else {
                    return `/login`;
                  }

                }}
                style={{ textDecoration: "none" }}
              >
                <img
                  src="/assets/images/icons/play-icon.png"
                  alt="Play Icon"
                  style={{
                    height: "150px", // Increased size from 80px to 100px
                    cursor: "pointer",
                    transition: "transform 0.3s ease, height 0.3s ease", // Added smooth height transition
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.transform = "scale(1.2)"; // Increased hover scale
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = "scale(1)"; // Reset scale
                  }}
                />
              </Link>
            </div>

            {/* Responsive Styles */}
            <style>
              {`
          @media (max-width: 768px) {
            div[style] {
              height: 70vh !important;
            }
            img[alt="Play Icon"] {
              height: 80px !important;
            }
          }
          @media (max-width: 480px) {
            div[style] {
              height: 60vh !important;
            }
            img[alt="Play Icon"] {
              height: 80px !important;
            }
          }
        `}
            </style>
          </div>

          {/* Movie Details Section */}
          <div className="container mt-5 text-light">
            {/* Title and Actions Section */}
            <div className="container text-light mt-5">
              <div className="row align-items-center mb-4">

                {/* Title and Description - 75% width on large screens, full width on small screens */}
                <div className="col-12 col-md-9 mb-3">
                  <h3 className="text-warning fw-bold">{movie?.title}</h3>
                  <p className="text-muted fs-5">{movie?.description}</p>
                </div>

                {/* Action Buttons - 25% width on large screens, full width on small screens */}
                <div className="col-12 col-md-3 d-flex flex-column flex-md-row align-items-center">
                  {/* Share Button */}
                  <button
                    onClick={handleShare}
                    className="btn btn-warning mb-2 w-100 d-md-block"
                    style={{
                      borderRadius: "20px",  // Smaller border-radius
                      fontWeight: "bold",
                      fontSize: "14px",  // Decrease font size
                      padding: "12px 20px",  // Reduce padding
                      width: "100%",  // Default full width
                      maxWidth: "60%",  // Limit width to 50% on larger screens
                      transition: "all 0.3s ease",
                    }}
                    onMouseEnter={(e) => (e.target.style.boxShadow = "0px 2px 10px rgba(255, 165, 0, 0.5)")}
                    onMouseLeave={(e) => (e.target.style.boxShadow = "none")}
                  >
                    <FiShare2 size={16} className="me-1" /> {/* Smaller icon */}
                    Share
                  </button>
                  {/* Watchlist Button */}
                  {/* {checkWatchlist ? (
                    <button
                      className="btn btn-danger w-100 mb-2 p-2"
                      style={{ borderRadius: "30px", fontWeight: "bold", transition: "all 0.3s ease" }}
                      onClick={removeFromWatchlistHandler}
                      onMouseEnter={(e) => (e.target.style.boxShadow = "0px 4px 15px rgba(220, 53, 69, 0.5)")}
                      onMouseLeave={(e) => (e.target.style.boxShadow = "none")}
                    >
                      Remove from Watchlist
                    </button>
                  ) : (
                    <button
                      className="btn btn-success w-100 mb-2 p-2"
                      style={{ borderRadius: "30px", fontWeight: "bold", transition: "all 0.3s ease" }}
                      onClick={addToWatchlistHandler}
                      onMouseEnter={(e) => (e.target.style.boxShadow = "0px 4px 15px rgba(40, 167, 69, 0.5)")}
                      onMouseLeave={(e) => (e.target.style.boxShadow = "none")}
                    >
                      Add to Watchlist
                    </button>
                  )} */}
                </div>
              </div>
            </div>


            {/* Crew Section */}
            {movie.Actors_list?.length > 0 && (
              <div className="mt-5">
                <h4 className="fw-bold text-warning">Crew</h4>
                <Slider {...crewSettingsVideos} className="mt-4">
                  {movie.Actors_list.map((actor, index) => (
                    <div
                      key={index}
                      className="text-center bg-dark p-3 rounded shadow-sm"
                      style={{ maxWidth: "280px", margin: "0 auto" }}
                    >
                      <img
                        src={actor.image}
                        alt={actor.name}
                        className="rounded-circle mb-3 shadow"
                        style={{ height: "225px", width: "225px", objectFit: "cover" }}
                      />
                      <div>
                        <span className="text-warning fw-bold">{actor.name}</span>
                        <br />
                        <small className="text-muted">{actor.asCharacter}</small>
                      </div>
                    </div>
                  ))}
                </Slider>
              </div>
            )}

            {/* Toast Notification */}
            <ToastContainer
              position="top-right"
              autoClose={2000}
              hideProgressBar={false}
              newestOnTop
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              className="toast-container"
            />
          </div>
        </div >
      )}

    </>
  );
};
export default MovieView;
